module.exports = __webpack_public_path__ + "img/hele-billedet-5.67ea6cfd.png";